module.exports = __webpack_public_path__ + "img/newsImg6-5.6c90abfc.png";